export class POSOutlet {
  id: number | 0;
  hotel_id: number;
  parameter_id: number;
  code: string;
  name: string;
  last_modified: Date | null;
  last_modified_by: number | null;
  created: Date | null;
  created_by: number | null;
  // default_bill_printer_id: number | null
  fo_working_date: Date | null;
  sort_order: number | 0;
  operating_end_time: string | Date;
  operating_start_time: string | Date;

  /**
   * PMS-763 Table Layout (ADR-0011). The outlet owns the canvas its tables are
   * positioned on. Numerics arrive as strings over JSON, hence the union.
   * layout_enabled false (the default for every existing outlet) hides the
   * Layout view entirely.
   */
  layout_image_url: string | null;
  layout_aspect_ratio: number | string | null;
  layout_enabled: boolean;
}
